import React, { ReactNode } from 'react';

import Tooltip from '@atlaskit/tooltip';

import { ContainerStyled } from './ContentWithIconTooltip.styled';

export type Props = {
  children: ReactNode;
  tooltipContent?: ReactNode;
  iconAfter?: ReactNode;
  iconBefore?: ReactNode;
};

export const ContentWithIconTooltip: React.FC<Props> = ({
  children,
  tooltipContent,
  iconAfter,
  iconBefore,
}: Props) => {
  const getIcon = (icon: ReactNode | undefined) => {
    if (!icon) {
      return null;
    }

    if (tooltipContent) {
      return <Tooltip content={tooltipContent}>{icon}</Tooltip>;
    }

    return icon;
  };

  return (
    <ContainerStyled>
      {getIcon(iconBefore)}
      {children}
      {getIcon(iconAfter)}
    </ContainerStyled>
  );
};
